import { Flex, IconButton, Text, VStack } from "@chakra-ui/react";
import { useField } from "formik";
import { InputControl, SelectControl } from "formik-chakra-ui";
import { RiDeleteBin6Line } from "react-icons/ri";
import { Card } from "src/components/Layout/Card";
import { type EligibilityDataPoint } from "src/generated/hooks/form-service/requests";
import * as RD from "src/types/remoteData";
import { DataPointSelect } from "./DataPointSelect";
import { type DateOperator } from "./dateCondition";

export function DateConditionCard({
  name,
  enrollmentPeriodId,
  dataPoints,
  onDelete,
}: {
  name: string;
  enrollmentPeriodId: string;
  dataPoints: RD.RemoteData<Error, EligibilityDataPoint[]>;
  onDelete: () => void;
}) {
  const [operatorField] = useField<DateOperator | "">(`${name}.operator`);
  const operator = operatorField.value;

  return (
    <Card showBorder>
      <VStack align="stretch" spacing={4}>
        <Flex align="center" justify="space-between" gap={3}>
          <Text fontSize="md" fontWeight="medium" color="blackAlpha.800">
            Date condition
          </Text>
          <IconButton
            aria-label="Delete date condition"
            icon={<RiDeleteBin6Line />}
            variant="outline"
            colorScheme="gray"
            size="sm"
            onClick={onDelete}
          />
        </Flex>

        <DataPointSelect
          name={`${name}.dataPointId`}
          enrollmentPeriodId={enrollmentPeriodId}
          dataPoints={dataPoints}
          dataPointType="Date"
        />

        <SelectControl
          name={`${name}.operator`}
          label="Is"
          selectProps={{ placeholder: "Select" }}
        >
          <option value="before">Before</option>
          <option value="after">After</option>
          <option value="between">Between</option>
        </SelectControl>

        {operator === "before" || operator === "after" ? (
          <InputControl
            name={`${name}.date`}
            label="Select date"
            inputProps={{ type: "date" }}
          />
        ) : null}

        {operator === "between" ? (
          <Flex align="stretch" gap={2}>
            <InputControl
              name={`${name}.date`}
              label="Start date"
              flexGrow={1}
              inputProps={{ type: "date" }}
            />
            <InputControl
              name={`${name}.endDate`}
              label="End date"
              flexGrow={1}
              inputProps={{ type: "date" }}
            />
          </Flex>
        ) : null}
      </VStack>
    </Card>
  );
}
